import JSEncrypt from 'jsencrypt'
import { CURRENT_CONFIG } from '../api/http/config'

const PUBLIC_KEY = CURRENT_CONFIG.loginPublicKey || 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAseQ2yb9Q9LYnBAvRJF2sjFk8OM8PszsAXTcmPSewKHQUyCypBnm5MyzTSodsIypa2ZdHZ1/4RSDOAR9z1jqgD4fSR8yWFgDBIieHEUw8tz2i9HTlG+N2F+sya42l8rH30Rz8qmHr8osYUGbikHr5XCqBaCFQvXzHlQe93onZQNEyy15Y3Yc24cSRSf/KmMyJgRTkSGe9lHgT7jbFLhB7yZiJXoVCfMxp7FUp3x6QDTkHIdhnxft80mcCDWZ+rsZ17Rb1sQQ8BgeSw1mSapXSpPppbJ24qFGc47Pgnb0xeWzBxTGcd9+Kjaxpi3SRFSG0LAnWuHrZE7rqwteS19BR1wIDAQAB'

/**
 * 使用 RSA 公钥加密文本（适用于较短内容，如密码）
 * 注意：若明文过长（超过117字节），需自行实现分段加密
 * @param plainText 明文
 * @returns 加密后的密文字符串，若加密失败或输入为空则返回空字符串
 */
export function rsaEncrypt (plainText: string): string {
  if (!plainText) return ''

  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(PUBLIC_KEY)

  const encrypted = encryptor.encrypt(plainText)
  return encrypted || ''
}
